<template>
  <div v-if="articleDataset.show_load_more" class="load-more-container col-xs-10 col-xs-push-1">
    <button
      class="load-more ripple-animation ripple-animation--white"
      @click.prevent="
        filterArticles(
          articleDataset.load_more_api_url,
          articleDataset.load_more_url,
          articleDataset.filter_data.tagging_attributes_more_articles,
        )
      "
    >
      <span>{{ articleDataset.filter_data.more_articles }}</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'loadmore',
  props: {
    articleDataset: { type: Object, required: true },
  },
  methods: {
    filterArticles(apiUrl, pushState) {
      /* istanbul ignore next */
      this.$parent.getData(apiUrl, pushState);
    },
  },
};
</script>
